import { Component, effect, inject, OnDestroy, OnInit, signal } from '@angular/core';

import { MatCheckboxChange } from '@angular/material/checkbox';

import { Subject, takeUntil } from 'rxjs';

import { FileType, FileTypeTexts } from '@empathy/global/data';

import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-file-upload-form',
  templateUrl: 'file-upload-form.component.html',
  styleUrls: ['./file-upload-form.component.scss']
})
export class FileUploadFormComponent implements OnInit, OnDestroy {
  valuesSelected$ = signal<string[]>([]);

  fileTypeTexts = FileTypeTexts;

  surveyEditorService = inject(SurveyEditorService);

  private destroyed$ = new Subject<void>();

  constructor() {
    effect(() => this.surveyEditorService.surveyEditor$().activeQuestion.get('fileTypes').setValue(this.valuesSelected$()));
  }

  ngOnInit(): void {
    this.listenToActivateAnotherFileUploadTypeQuestion();
    this.mapFileTypes();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onMultiOptionChanged(change: MatCheckboxChange, fileType: string): void {
    if (change.checked) {
      this.valuesSelected$.update((values) => [...values, fileType]);
    } else {
      this.valuesSelected$.update((values) => values.filter((value) => value !== fileType));
    }
  }

  private mapFileTypes(): void {
    const fileTypesControl = this.surveyEditorService.surveyEditor$().activeQuestion.get('fileTypes');
    if (fileTypesControl?.value) {
      const fileTypes = fileTypesControl.value as FileType[];
      this.valuesSelected$.set(fileTypes);
    }
  }

  private listenToActivateAnotherFileUploadTypeQuestion(): void {
    this.surveyEditorService
      .surveyEditor$()
      .questionActivated$.pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.mapFileTypes();
      });
  }
}
